import ApiService from '../../../shared/services/ApiService';

export default {
    getInit() {
        return ApiService.get('/web-init');
    },

    getInitLists() {
        return ApiService.get('/init-lists');
    },

    updateIntroSteps(data) {
        return ApiService.post('/update-intro', data);
    },

    updateTimezone(data) {
        return ApiService.post('/update-timezone', data);
    }
}